import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "7:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-650.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "7:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-650.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "7:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-650.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "7:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-650.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "7:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-650.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "7:6": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-650.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "7:7": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-650.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
};

export default components;
